import { Text, TextProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface SectionLabelProps extends TextProps {
  children: ReactNode;
}

export function SectionLabel({ children, ...props }: SectionLabelProps) {
  return (
    <Text textStyle="sectionLabel" {...props}>
      {children}
    </Text>
  );
}
